import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { SubscriptionProcessingPage } from '../pages/subscription-processing/subscription-processing.page';
import { SubscriptionFlowService } from '../services/subscription-flow.service';

export const subscriptionProcessingUnloadGuard: CanDeactivateFn<SubscriptionProcessingPage> = (
  component,
  currentRoute,
  currentState,
  nextState
) => {
  const flow = inject(SubscriptionFlowService);
  const isPending: boolean = flow.isFlowActive() && flow.isPendingActivation();
  if (!isPending) return true;

  const confirmed: boolean = confirm(
    'Your subscription is being activated. Leaving now may cause issues with your payment. Are you sure you want to leave?'
  );

  if (confirmed) {
    flow.clearFlow();
  }

  return confirmed;
};
